import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';

@Injectable({
	providedIn: 'root'
})
export class WarehouseService {

	private _warehouseId;
	private _warehouseLastOrg;
	private _warehouseName;
	private _warehouseInfo;

	public onWarehouseChange: EventEmitter<number> = new EventEmitter();

	get warehouseId() {
		if (this.app.org !== this._warehouseLastOrg) {
			this._warehouseLastOrg = null;
			this._warehouseId = null;
		}

		return this._warehouseId;
	}

	set warehouseId(value) {
		value = parseInt(value, 10) || null;
		if (this._warehouseLastOrg !== this.app.org || this._warehouseId !== value) {
			this._warehouseLastOrg = this.app.org;
			this._warehouseId = value;
			this._warehouseName = '';

			if (value) {
				this.api.inventory.getWarehouse(value, data => {
					if (data.record.id === this._warehouseId) this._warehouseName = data.record.name; this._warehouseInfo = data;
				});
			}
		}
	}

	get warehouseName() { return this._warehouseName; }
	get warehouseInfo() { return this._warehouseInfo; }

	stockedItemOrder = 'warehouse_sku';
	expandedLocations = {};

	constructor(
		private app: AppService,
		private api: ApiService
	) { }

	getTransactionStatusName(status) {
		switch (status) {
			// PO
			case 'po_sent': return 'Incoming';
			case 'po_confirmed': return 'Incoming';

			// Transaction In/Out
			case 'cancelled': return 'Cancelled';

			// Transaction In
			case 'arrived': return 'Arrived';
			case 'receiving': return 'Receiving';
			case 'put_away': return 'Location Assignment';
			case 'received': return 'Completed';

			// Transaction Out
			case 'selecting': return 'Selecting';
			case 'confirmed': return 'Confirmed';
			case 'picking': return 'Picking';
			case 'ready_to_dispatch': return 'Ready to Dispatch';
			case 'dispatched': return 'Dispatched';
			case 'delivered': return 'Delivered';
			case 'part_delivered': return 'Partially Delivered';
		}

		return '';
	}

	getTransactionStatusColor(status) {
		switch (status) {
			// PO
			case 'po_sent': return 'warning';
			case 'po_confirmed': return 'warning';

			// Transaction In/Out
			case 'cancelled': return 'danger';

			// Transaction In
			case 'arrived': return 'medium';
			case 'receiving': return 'info';
			case 'put_away': return 'secondary';
			case 'received': return 'success';

			// Transaction Out
			case 'selecting': return 'info';
			case 'confirmed': return 'warning';
			case 'picking': return 'info';
			case 'ready_to_dispatch': return 'medium';
			case 'dispatched': return 'success';
			case 'delivered': return 'success';
			case 'part_delivered': return 'success';
		}

		return '';
	}

	getTransactionStatusTooltip(status) {
		switch (status) {
			// PO
			case 'po_sent': return 'Purchase order sent to supplier';
			case 'po_confirmed': return 'Purchase order confirmed by supplier';

			// Transaction In/Out
			case 'cancelled': return 'Transfer cancelled';

			// Transaction In
			case 'arrived': return 'Items being checked in from courier';
			case 'receiving': return 'Items being checked in from courier';
			case 'put_away': return 'Items received in loading bay, ready for storage';
			case 'received': return 'Items are received';

			// Transaction Out
			case 'selecting': return 'Choose items to send (may be part of the order)';
			case 'confirmed': return 'Transfer is ready to be picked';
			case 'picking': return 'Picking chosen items for dispatch';
			case 'ready_to_dispatch': return 'Items picked and ready to ship';
			case 'dispatched': return 'Items are dispatched';
			case 'delivered': return 'Items are delivered';
			case 'part_delivered': return 'Items are partially delivered';
		}

		return '';
	}

	getWarehouseType(type) {
		switch (type) {
			case 'warehouse': return 'Warehouse Location';
			case 'project_site': return 'Site Location';
			case 'site': return 'Custom Location';
			case 'van': return 'Van';
		}
		return '';
	}

	getWarehouseIcon(type) {
		switch (type) {
			case 'warehouse': return 'wq wq-warehouse';
			case 'project_site': return 'wq wq-booking-project';
			case 'site': return 'wq wq-client';
			case 'van': return 'wq wq-truck';
		}
		return '';
	}

}
